/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Return_CrumbInputs */

const en_payment_return_crumb = /** @type {(inputs: Payment_Return_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const pl_payment_return_crumb = /** @type {(inputs: Payment_Return_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatność`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Payment_Return_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const payment_return_crumb = /** @type {((inputs?: Payment_Return_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Return_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_payment_return_crumb(inputs)
	return en_payment_return_crumb(inputs)
});